import { render } from "./AddBanner.vue?vue&type=template&id=20ef3ed5&scoped=true"
import script from "./AddBanner.vue?vue&type=script&lang=js"
export * from "./AddBanner.vue?vue&type=script&lang=js"

import "./AddBanner.vue?vue&type=style&index=0&id=20ef3ed5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ef3ed5"]])

export default __exports__